var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "back-button",
    on: {
      "click": _vm.onClick
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "left"
    }
  }), _vm._v(" " + _vm._s(_vm.text.toUpperCase()) + " ")], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }